const Win32ErrorCodes = {
    ERROR_FILE_NOT_FOUND: { text: 'File not found', code: 2 },
    ERROR_PATH_NOT_FOUND: { text: 'The system cannot find the path specified', code: 3 },
    ERROR_ACCESS_DENIED: { text: 'Access Denied', code: 5 },
    ERROR_INVALID_ACCESS: { text: 'The access code is invalid', code: 12 },
    ERROR_CANNOT_MAKE: { text: 'The directory or file cannot be created', code: 82 },
    ERROR_INVALID_DATA: { text: 'The data is invalid', code: 13 },
    ERROR_NO_MORE_FILES: { text: 'There are no more files', code: 18 },
    ERROR_BAD_COMMAND: { text: 'The device does not recognize the command', code: 22 },
    ERROR_BAD_LENGTH: { text: 'The program issued a command but the command length is incorrect', code: 24 },
    ERROR_SHARING_VIOLATION: { text: 'The process cannot access the file because it is being used by another process', code: 32 },
    ERROR_HANDLE_EOF: { text: 'Reached the end of the file', code: 38 },
    ERROR_HANDLE_DISK_FULL: { text: 'The disk is full', code: 39 },
    ERROR_NOT_SUPPORTED: { text: 'The request is not supported', code: 50 },
    ERROR_FILE_EXISTS: { text: 'The file exists', code: 80 },
    ERROR_INVALID_PARAMETER: { text: 'The parameter is incorrect', code: 87 },
    ERROR_DISK_FULL: { text: 'There is not enough space on the disk', code: 112 },
    ERROR_INVALID_NAME: { text: 'The filename, directory name, or volume label syntax is incorrect', code: 123 },
    ERROR_DIR_NOT_EMPTY: { text: 'The directory is not empty', code: 145 },
    ERROR_BAD_PATHNAME: { text: 'The specified path is invalid', code: 161 },
    ERROR_ALREADY_EXISTS: { text: 'Cannot create a file when that file already exists', code: 183 },
    WAIT_TIMEOUT: { text: 'The wait operation timed out', code: 258 },
    ERROR_DIRECTORY: { text: 'The directory name is invalid', code: 267 },
    ERROR_CANCELLED: { text: 'The operation was canceled by the user', code: 1223 },
    E_FAIL: { text: 'Unspecified failure', code: 0x8000400 }
}

export function getWin32ErrorMessage(errorCode: number): string {
    const error = Object.values(Win32ErrorCodes).find(error => error.code === errorCode);
    return error ? error.text : `Error: ${errorCode.toString(16)}`;
}